import Vue from 'vue'
import Router from 'vue-router'
import AppConstants from '../constants/app.constants'
import { store } from '@/store.js'
import FlashMessage from '../common/flash-message.component'
// マッピング
import ItemMapping from '@/components/mappings/ItemMapping'
import ChuteMapping from '@/components/mappings/ChuteMapping'
import ShopMapping from '@/components/mappings/ShopMapping'
import SortingMapping from '@/components/mappings/SortingMapping'
import TaskMapping from '@/components/mappings/TaskMapping'
import CsvResultsMapping from '@/components/mappings/CsvResultsMapping'

// マスタテーブル
import ItemMaster from '@/components/mst-tables/ItemMaster'
import ChuteMaster from '@/components/mst-tables/ChuteMaster'
import ShopMaster from '@/components/mst-tables/ShopMaster'
import DeviceMaster from '@/components/mst-tables/DeviceMaster'
import DetailDeviceMaster from '@/components/mst-tables/DetailDeviceMaster'
import InductionMaster from '@/components/mst-tables/InductionMaster'
import SortingMaster from '@/components/mst-tables/SortingMaster'
import TaskStatement from '@/components/mst-tables/TaskStatement'
import TaskHistory from '@/components/mst-tables/TaskHistory'
import BatchControl from '@/components/mst-tables/BatchControl'
import UserInfo from '@/components/user-info/UserInfo.vue'
import ChangePassword from '@/components/user-info/ChangePassword.vue'
import TaskTypeSettingMaster from '@/components/mst-tables/TaskTypeSettingMaster'
import TaskTypeMaster from '@/components/mst-tables/TaskTypeMaster'
import RcsMaster from '@/components/mst-tables/RcsMaster'

// CSVアップロード
import CsvUpload from '@/components/CsvUpload'
// ログ情報
import LogInformation from '@/components/LogInformation'
// 設定
import GeneralSetting from '@/components/GeneralSetting'
import TaskTypeSetting from '@/components/task-type-setting/TaskTypeSetting'
// Login
import Login from '@/components/Login'
// SettingWizard
import SettingWizardComponent from '@/components/SettingWizardComponent'
// Mapping
import Mapping from '@/components/layouts/Mapping'
// Master
import Master from '@/components/layouts/Master'
// Work
import Work from '@/components/layouts/Work'
// Dashboard
import TsortDashboard from '@/components/TsortDashboard'
// layoutsファイル
import header from '@/components/layouts/Header'
import MainContent from '@/components/layouts/MainContent'
import subMenu from '@/components/layouts/SubMenu'
// User Management
import UserManagement from '@/components/hub-user/UserManagement'
// Hub Setting
import HubSetting from '@/components/hub-user/HubSetting'
// RoboHI
import RoboHI from '@/components/RoboHI'
import DevSetting from '@/components/DevSetting'
// Filter Menu
import { buildMenuList } from '../common/filter-menu'

import HTTPClient from '../common/http-client'
import RouterUtils from '../_helpers/router.util'
import { SettingWizardStep } from '../enums/setting-wizard-step.enums'
import UseCaseSelectionService from '../_services/use-case-selection.service'
import ErrorCdMsgConstants from '../constants/error-cd-msg.constants'
import HTTPUtils from '../_helpers/http.util'
import WebRcs from '../components/web-rcs/WebRcs.vue'

Vue.component('vue-header', header)
Vue.component('sub-menu', subMenu)
Vue.component('app-main-content', MainContent)

Vue.use(Router)
// Moment 追加
const moment = require('moment')
require('moment/locale/ja')
Vue.use(require('vue-moment'), {
  moment
})

export const router = new Router({
  routes: [
    {
      path: '/login',
      name: AppConstants.LOGIN_ROUTER_NAME,
      component: Login,
      meta: {
        title: 'ログイン'
      }
    },
    {
      path: '/setting-wizard',
      name: AppConstants.SETTING_WIZARD_ROUTER_NAME,
      component: SettingWizardComponent,
      meta: {
        title: '+Hubへようこそ'
      }
    },
    {
      path: '/',
      component: MainContent,
      meta: { name: AppConstants.MAIN_CONTENT_ROUTER_NAME, breadCrumb: 'TOP' },
      redirect: 'dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: TsortDashboard,
          workMode: AppConstants.WORK_MODE_T_SORT,
          meta: { noButtonSpace: true, noActionButtonsContainer: true }
        },
        {
          path: 'robo-hi',
          name: 'RoboHiDashboard',
          component: RoboHI,
          meta: { titleMenu: 'Robo-HI', workMode: AppConstants.WORK_MODE_RO_BO_HI, hasMainVerticalScroll: true, noButtonSpace: true }
        },
        {
          path: 'mapping',
          name: 'Mapping',
          component: Mapping,
          meta: { title: 'マッピング設定', subTitle: '' },
          children: [
            // マッピング
            {
              path: 'item',
              name: 'ItemMapping',
              component: ItemMapping,
              meta: { titleMenu: '商品マスタ', noActionButtonsContainer: true, noButtonSpace: true }
            },
            {
              path: 'chute',
              name: 'ChuteMapping',
              component: ChuteMapping,
              meta: { titleMenu: 'シュートマスタ', noActionButtonsContainer: true, noButtonSpace: true }
            },
            {
              path: 'shop',
              name: 'ShopMapping',
              component: ShopMapping,
              meta: { titleMenu: '店舗マスタ', noActionButtonsContainer: true, noButtonSpace: true }
            },
            {
              path: 'sorting',
              name: 'SortingMapping',
              component: SortingMapping,
              meta: { titleMenu: '仕分けマスタ', noActionButtonsContainer: true, noButtonSpace: true }
            },
            {
              path: 'task',
              name: 'TaskMapping',
              component: TaskMapping,
              meta: { titleMenu: '作業指示データ', noActionButtonsContainer: true, noButtonSpace: true }
            },
            {
              path: 'csv-results',
              name: 'CsvResultsMapping',
              component: CsvResultsMapping,
              meta: { titleMenu: 'CSV実績データ', noActionButtonsContainer: true, noButtonSpace: true }
            }
          ]
        },
        // CSV アップロード
        {
          path: 'upload',
          name: AppConstants.CSV_UPLOAD,
          component: CsvUpload,
          meta: { title: 'アップロード', subTitle: '', noActionButtonsContainer: true }
        },
        // add new param work
        {
          path: 'work',
          name: 'Work',
          component: Work,
          meta: { title: '作業管理', subTitle: '仕分け作業の操作・確認ができる画面です。' },
          children: [
            {
              path: 'batch-management',
              name: 'BatchControl',
              component: BatchControl,
              meta: { titleMenu: 'バッチ' }
            },
            {
              path: 'task',
              name: 'TaskStatement',
              component: TaskStatement,
              meta: { titleMenu: 'タスク明細' }
            },
            {
              path: 'task-hst',
              name: 'TaskHistory',
              component: TaskHistory,
              meta: { titleMenu: 'タスク履歴' }
            }
          ]
        },
        {
          path: 'log-information',
          name: 'LogInformation',
          component: LogInformation,
          meta: { title: 'ログ', subTitle: '' }
        },
        {
          path: 'general-setting',
          component: GeneralSetting,
          name: 'GeneralSetting',
          meta: { title: '全体設定', subTitle: '', noActionButtonsContainer: true }
        },
        {
          path: 'task-type-setting',
          component: TaskTypeSetting,
          name: 'TaskTypeSetting',
          meta: { title: 't-Sort仕分けの設定', subTitle: 'アプリ特有の設定を行ってください。', noActionButtonsContainer: true }
        },
        {
          path: 'user-info',
          name: 'UserInfo',
          component: UserInfo,
          meta: { title: '', noActionButtonsContainer: true, hasMainVerticalScroll: true },
          children: []
        },
        {
          path: 'change-password',
          name: 'Change Password',
          meta: { title: '', noActionButtonsContainer: true, hasMainVerticalScroll: true },
          component: ChangePassword
        },
        // add new param master
        {
          path: 'master',
          name: 'Master',
          component: Master,
          meta: { title: 'マスタ', subTitle: 'マスタデータを閲覧、個別にエクスポート・インポートが行えます。' },
          children: [
            // マスターテーブル
            {
              path: 'item',
              name: 'ItemMaster',
              component: ItemMaster,
              meta: { titleMenu: '商品マスタ' }
            },
            {
              path: 'chute',
              name: 'ChuteMaster',
              component: ChuteMaster,
              meta: { titleMenu: 'シュートマスタ' }
            },
            {
              path: 'shop',
              name: 'ShopMaster',
              component: ShopMaster,
              meta: { titleMenu: '店舗マスタ' }
            },
            {
              path: 'device',
              name: 'DeviceMaster',
              component: DeviceMaster,
              meta: { titleMenu: 'デバイスマスタ', hasMainVerticalScroll: true, noButtonSpace: true, noActionButtonsContainer: true }
            },
            {
              path: 'detail-device',
              name: 'DetailDeviceMaster',
              component: DetailDeviceMaster,
              meta: { titleMenu: 'デバイス明細マスタ' }
            },
            {
              path: 'induction',
              name: 'InductionMaster',
              component: InductionMaster,
              meta: { titleMenu: 'インダクションマスタ' }
            },
            {
              path: 'sorting',
              name: 'SortingMaster',
              component: SortingMaster,
              meta: { titleMenu: '仕分けマスタ' }
            },
            {
              path: '/master/task-type-setting',
              name: 'TaskTypeSettingMaster',
              component: TaskTypeSettingMaster,
              meta: { titleMenu: 'タスクタイプ設定マスタ' }
            },
            {
              path: '/master/task-type',
              name: 'TaskTypeMaster',
              component: TaskTypeMaster,
              meta: { titleMenu: 'タスクタイプマスタ' }
            },
            {
              path: 'rcs',
              name: 'RcsMaster',
              component: RcsMaster,
              meta: { titleMenu: 'RCSマスタ' }
            }
          ]
        },
        {
          path: 'hub-user',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: 'hub-setting',
          name: 'HubSetting',
          component: HubSetting
        },
        {
          path: 'web-rcs',
          name: 'WebRcs',
          component: WebRcs
        },
        {
          path: 'dev-setting',
          name: AppConstants.DEV_SETTING_ROUTER_NAME,
          component: DevSetting,
          meta: { title: '開発者設定', subTitle: '' }
        }
      ]
    }
  ]
})
let setting = null
let useCaseSelections = null
let setup = null
let appendStoredQueryToUrl = false

router.beforeEach(async(to, from, next) => {
  const publicPages = ['/old', AppConstants.LOGIN_URL]
  const authRequired = !publicPages.includes(to.path)
  if (!authRequired) {
    return next()
  }

  // eslint-disable-next-line no-undef
  const authMode = config.AUTH_MODE
  const loggedIn = store.state.auth.status.loggedIn
  // 認証フラグが有効になっているときに制限されたページにアクセスしようとしましたが、ログインしていませんでした
  if (authMode && authRequired && !loggedIn) {
    // ログインページにリダイレクト
    return next(AppConstants.LOGIN_URL)
  }

  if (to.meta.workMode === AppConstants.WORK_MODE_RO_BO_HI) {
    store.commit('setWorkMode', AppConstants.WORK_MODE_RO_BO_HI)
  } else if (to.name === 'Dashboard') {
    store.commit('setWorkMode', AppConstants.WORK_MODE_T_SORT)
  }

  // Pages are not accepted without login
  let wmsName = null
  let isName = null
  let isExpiredTokenError = false
  if (!useCaseSelections) {
    useCaseSelections = await UseCaseSelectionService.getInstance()
      .getUseCaseSelections()
      .catch(err => {
        // 403エラーの場合、権限エラーメッセージを表示します
        if (HTTPUtils.is403Error(err)) {
          FlashMessage.getInstance().showErrorMsgWithErrorCode(
            ErrorCdMsgConstants.FUNC_HUB_BASE_LOGIN_PERMISSION_ERR_CD,
            ErrorCdMsgConstants.FUNC_HUB_BASE_LOGIN_PERMISSION_ERR_MSG
          )
          store.dispatch('auth/logout', { root: true })
          throw err
        }
        isExpiredTokenError = HTTPUtils.isExpiredTokenError(err)
      })
    if (useCaseSelections) {
      store.dispatch('useCaseSelection/updateUseCaseSelections', useCaseSelections, { root: true })
    } else if (isExpiredTokenError) {
      return next(AppConstants.LOGIN_URL)
    }
  }
  if (!setting) {
    setting = await HTTPClient.getInstance().http.get('/setting').catch(err => {
      console.log(err)
    })
    if (setting && setting.data) {
      store.dispatch('setting/insertSetting', setting, { root: true })
    }
  }
  const mstMenu = AppConstants.MST_MENU
  if (setting && setting.data) {
    wmsName = setting.data.mstSetting ? setting.data.mstSetting.wmsName : null
    isName = setting.data.mstSetting ? setting.data.mstSetting.isName : null
    // get data mstMenu
    if (setting.data.mstMenu) {
      for (let i = 0; i < setting.data.mstMenu.length; i++) {
        if (setting.data.mstMenu[i]) {
          mstMenu[setting.data.mstMenu[i].menuNo] = setting.data.mstMenu[i].visible === 1
        }
      }
    }
    store.dispatch('socket/setSocketEnabledFlag', setting.data.socketEnabled, { root: true })
  }
  // バックエンド障害によるログイン
  if (to.name !== AppConstants.LOGIN_ROUTER_NAME && !useCaseSelections && !setting) {
    FlashMessage.getInstance().showErrorMsgWithErrorCode(
      ErrorCdMsgConstants.FUNC_SERVER_CONNECTION_ERR_CD,
      ErrorCdMsgConstants.FUNC_SERVER_CONNECTION_ERR_MSG
    )
  }

  // 別のページを変更するときに設定データを更新します。
  if (!setup && to.name !== AppConstants.LOGIN_ROUTER_NAME) {
    const deptId = store.getters['auth/getUserDetails'].deptId
    setup = await store.dispatch(
      'settingWizardStore/getSetupDataSettingWizard',
      { hubId: deptId },
      { root: true }
    )
    // セットアップ必須フラグが false の場合、
    // セットアップを無視するように セットアップマスタデータを更新します。
    const includeStep1 = store.getters['settingWizardStore/getInfoSteps'].includes(1)
    if (!includeStep1) {
      if (setting && setting.data && setting.data.mstSetting.isRequiredSetup === AppConstants.MST_SETTING_NOT_REQUIRED_SETUP) {
        const user = store.state.auth.user
        setup = await store.dispatch('settingWizardStore/updateSetupData',
          {
            hubId: user.deptId,
            step: `${SettingWizardStep.START_SETUP_STEP},${SettingWizardStep.GENERAL_SETTING_STEP}`,
            finishedSetup: AppConstants.MST_SETUP_FINISHED_SETUP
          }
        )
      }
    }
  }
  // => redirect to change-password page
  if ((to.redirectedFrom === '/')) {
    if (store.getters['checkPassword/getChangePasswordFlag']) {
      return next('/change-password')
    }
  }

  if (FlashMessage.isCreated() && store.getters.getCloseIconErrMsgMode) {
    // 表示されているエラーメッセージをすべてクリアする
    FlashMessage.getInstance().hideAllMessages()
  }

  if (publicPages.includes(to.path)) {
    // Reset setting variable before displaying screen
    resetData()
    return next()
  }

  // filter menu children by type
  const menus = buildMenuList(mstMenu)
  for (let key in menus) {
    const parentMenuName = Object.keys(menus[key])[0]
    const visibleFlags = Object.values(menus[key])[0]
    const noChildrenVisible = visibleFlags.every(element => element === false)
    // redirect to dashboard page if the current route has no visible children
    if ('/'.concat(parentMenuName.toLocaleLowerCase()) === to.path && noChildrenVisible) {
      return next('/dashboard')
    } else {
      continue
    }
  }
  let routeWithFullOptions = RouterUtils.getRouteWithFullOptions(router.options.routes, to.name)
  const firstRoutePath = RouterUtils.getFirstChildRoutePath(routeWithFullOptions, mstMenu)
  const routeToPath = to.path.charAt(to.path.length - 1) === '/' ? to.path : to.path.concat('/')
  if (firstRoutePath) {
    return next(routeToPath + firstRoutePath)
  }
  // get current route name
  let parentRoute = RouterUtils.getParentRoute(to)
  if (parentRoute) {
    let parentRouteName = parentRoute.name
    routeWithFullOptions = RouterUtils.getRouteWithFullOptions(router.options.routes, parentRouteName)
    if (routeWithFullOptions) {
      let pageTitle = routeWithFullOptions.meta
      if (to.name === AppConstants.CSV_UPLOAD) {
        pageTitle.subTitle = `${wmsName || ''}のデータを取り込みできます。取り込み先を選択しアップロードします。`
      }
      let subMenus = routeWithFullOptions.children
      if (to.path.indexOf('/master/') !== -1 && store.getters['useCaseSelection/isOnlyNoTaskSortUseCase']) {
        subMenus = RouterUtils.getCurrentChildrenRoute(subMenus, AppConstants.NO_TASK_SORT_HIDDEN_MASTER_PATHS)
      }
      // To Mapping Path
      if (to.path.indexOf('/mapping/') !== -1) {
        pageTitle.subTitle = `${wmsName || ''}と${isName || ''}の項目を紐づけてください。`
        if (store.getters['useCaseSelection/isOnlyNoTaskSortUseCase']) {
          subMenus = RouterUtils.getCurrentChildrenRoute(subMenus, AppConstants.NO_TASK_SORT_HIDDEN_MAPPING_PATHS)
        }
      }
      store.dispatch(
        'subMenus/addChildrenRoute',
        {
          pageTitle: pageTitle || {},
          subMenus: subMenus || []
        },
        { root: true }
      )
    }
    store.commit('addMenuActive', parentRouteName)
  }
  // Check to append query object in localStorage to router
  const storedQueryObj = RouterUtils.getQueryObjectFromStorageByRouterName(to.name)
  if (storedQueryObj && !appendStoredQueryToUrl) {
    appendStoredQueryToUrl = true
    return next({path: to.path, query: {...to.query, ...RouterUtils.getQueryObjectFromStorageByRouterName(to.name)}})
  }

  // ステータス設定ウィザードの確認・更新を行います。
  if (to.name !== AppConstants.SETTING_WIZARD_ROUTER_NAME) {
    const infoSW = store.getters['settingWizardStore/getSetupData']
    let statusSW = 0
    if (infoSW && infoSW.mstSetup) {
      statusSW = infoSW.mstSetup.finishedSetup
    }

    // セットアップステータスが未完了の場合に表示されるメニュー設定を更新します
    if (!statusSW) {
      store.dispatch('settingWizardStore/updateMenuStatus', 1, { root: true })
    }
    store.dispatch('settingWizardStore/updateSetupStatus', statusSW, { root: true })
  }

  // ユーザーが設定ウィザード画面に移動することを確認します
  const includeStep1 = store.getters['settingWizardStore/getInfoSteps'].includes(1)
  if (to.name === AppConstants.SETTING_WIZARD_ROUTER_NAME &&
    includeStep1) {
    return next('/dashboard')
  } else if (to.name === AppConstants.DASHBOARD_ROUTER_NAME &&
    !includeStep1) {
    return next('/setting-wizard')
  }

  // Reset setting variable before displaying screen
  resetData()
  next()
})

export default router
// Reset setting variable before displaying screen
function resetData() {
  setting = null
  useCaseSelections = null
  setup = null
  appendStoredQueryToUrl = false
}



// WEBPACK FOOTER //
// ./src/router/index.js